import { Component } from "@angular/core";
import {
  AbstractWidgetComponent,
  ContextChange,
  MasterDetailListEntry, TranslationService,
  WidgetStyle
} from "@sdbn/common";
import { SimulatorMenuEntry } from "../yard-simulator.model";

@Component({
  selector: "app-yard-simulator",
  templateUrl: "./yard-simulator.component.html",
  styleUrls: ["./yard-simulator.component.scss"],
})
export class YardSimulatorComponent extends AbstractWidgetComponent {
  selectedMenuEntry: SimulatorMenuEntry;

  menuEntries = [
    new SimulatorMenuEntry({
      identifier: "number-plate-scan",
      listTitle: this.translationService.translate(
        "tmc-yard.ui.admin.yard-simulator.menu-entry.number-plate-scan"
      ),
    }),
    new SimulatorMenuEntry({
      identifier: "rfid-reader",
      listTitle: this.translationService.translate(
        "tmc-yard.ui.admin.yard-simulator.menu-entry.rfid-reader"
      ),
    }),
    new SimulatorMenuEntry({
      identifier: "barcode-reader",
      listTitle: this.translationService.translate(
        "tmc-yard.ui.admin.yard-simulator.menu-entry.barcode-reader"
      ),
    }),
  ];

  onContextChange(contextChange: ContextChange): void {}

  onSetElementAndContext(): void {}

  onSimulatorMenuEntryChanged(entry: MasterDetailListEntry) {
    this.selectedMenuEntry = entry as SimulatorMenuEntry;
  }

  constructor(public translationService: TranslationService) {
    super();
    this.selectedMenuEntry = this.menuEntries[0];
  }

  ngOnInit() {}

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }
}
